import React from 'react'

import { Chip, Theme } from '@material-ui/core'
import { BidStatus, getUiString, RFPStatus } from '../../models'

interface RFPStatusBadgeProps {
    theme: Theme
    status: RFPStatus | BidStatus
    style?: { container?: React.CSSProperties; text?: React.CSSProperties }
}

const CHIP_COLORS: Record<string, { background: string; color: string }> = {
    [RFPStatus.DRAFT]: { background: '#EEEEEE', color: '#424242' },
    [RFPStatus.PUBLISHED]: { background: '#BBDEFB', color: '#0D47A1' },
    [RFPStatus.CLOSED]: { background: '#C8E6C9', color: '#1B5E20' },
    [RFPStatus.ARCHIVED]: { background: '#E0E0E0', color: '#424242' },
    [RFPStatus.FAILED]: { background: '#FFCDD2', color: '#B71C1C' },
    [RFPStatus.SELECT_VENDOR]: { background: '#FFF3CD', color: '#6D4C00' },
    [BidStatus.INVITATION]: { background: '#EEEEEE', color: '#424242' },
    [BidStatus.SUBMITTED]: { background: '#FFF3CD', color: '#6D4C00' },
    [BidStatus.REVIEWED]: { background: '#FFE0B2', color: '#E65100' },
    [BidStatus.ACCEPTED]: { background: '#C8E6C9', color: '#1B5E20' },
    [BidStatus.DECLINED]: { background: '#FFCDD2', color: '#B71C1C' },
}

export const RFPStatusBadge = (props: RFPStatusBadgeProps) => {
    const { status, style } = props
    const colors = CHIP_COLORS[status] || {
        background: '#EEEEEE',
        color: '#424242',
    }

    return (
        <Chip
            size="small"
            label={getUiString(status)}
            style={{
                backgroundColor: colors.background,
                color: colors.color,
                fontWeight: 700,
                height: 24,
                ...style?.container,
                ...style?.text,
            }}
        />
    )
}
